(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nevox-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nevox-header')) {
 customElements.define('nevox-header', class extends HTMLElement {
  connectedCallback() {
   this.controller = new AbortController();
   const opts = {signal:this.controller.signal};
   const dialog = this.querySelector('dialog');
   this.dialog = dialog;
   this.querySelector('[data-nx-open]').addEventListener('click', () => {dialog.showModal();this.previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';},opts);
   this.querySelector('[data-nx-close]').addEventListener('click', () => dialog.close(),opts);
   dialog.addEventListener('close',()=>{document.body.style.overflow=this.previousOverflow || '';},opts);
   dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}},opts);
   this.addEventListener('keydown',e=>{if(e.key==='Escape')this.querySelectorAll('details[open]').forEach(d=>d.open=false);},opts);
   document.addEventListener('click',e=>{if(!this.contains(e.target))this.querySelectorAll('details[open]').forEach(d=>d.open=false);},opts);
   this.querySelectorAll('details').forEach(d=>d.addEventListener('toggle',()=>{if(d.open)d.parentElement.parentElement.querySelectorAll(':scope > li > details').forEach(other=>{if(other!==d)other.open=false;});},opts));
  }
  disconnectedCallback(){if(this.dialog?.open){this.dialog.close();document.body.style.overflow=this.previousOverflow||'';}this.controller?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();
})();
